/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/MindHarborOrderHistory/UserOrderHistoryService',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
    'use strict';

    function getOrders(request) {
        return $.proxyRequest({
            url: '/api/mindharbor/orderHistory/search',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(request)
        });
    }

    function getOrderDetails(orderNo) {
        return $.proxyRequest({
            url: '/api/mindharbor/orderHistory/details/' + orderNo,
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        });
    }

    function getCustomerShipTos(customerId) {
        return $.proxyRequest({
            url: '/api/hierarchicalorganization/shiptos/' + customerId,
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        });
    }

    function getItemHistory(invMastUid, shipToId) {
        var request = { 'InvMastUid': invMastUid, 'ShipToId': shipToId };
        return $.proxyRequest({
            url: '/api/mindharbor/orderHistory/itemHistory/',
            type: 'POST',
            data: JSON.stringify(request),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        });
    }

    function getItemHistoryDetail(invMastUid, shipToId) {
        var request = { 'InvMastUid': invMastUid, 'ShipToId': shipToId };
        return $.proxyRequest({
            url: '/api/mindharbor/orderHistory/itemHistoryDetail/',
            type: 'POST',
            data: JSON.stringify(request),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        });
    }

    var UserOrderHistoryService = {
        getOrders: getOrders,
        getOrderDetails: getOrderDetails,
        getCustomerShipTos: getCustomerShipTos,
        getItemHistory: getItemHistory,
        getItemHistoryDetail: getItemHistoryDetail
    };

    Roc.Logger.debug('UserOrderHistoryService.js Loaded:', UserOrderHistoryService);

    return UserOrderHistoryService;
});
